import { render, staticRenderFns } from "./RsaConfigurazionePrestazioniAmbulatorialiListPage.vue?vue&type=template&id=72fb93d6"
import script from "./RsaConfigurazionePrestazioniAmbulatorialiListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazionePrestazioniAmbulatorialiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports